"use client";

import { useState } from "react";
import "./GridProjects.css";
import { ProjectSample } from "../../../shared/ui/ProjectSample/ProjectSample";
import { Tags } from "@/shared/ui/Tags/Tags";
import { IGridProjects } from "../types";

const GridProjectsClient: React.FC<IGridProjects> = ({
  tagsArr,
  projectsList,
}) => {
  const tags = tagsArr.map(
    (i: { attributes: { tag: string } }) => i.attributes.tag,
  );
  const [filter, setFilter] = useState(tags[0]);
  const handleClick = (i: any) => {
    setFilter(i);
  };

  return (
    <>
      <Tags tags={tags} filter={filter} handleClick={handleClick} />
      <div className={"portfolio__itemsContainer wrapper"}>
        {projectsList.map((i) => (
          <ProjectSample
            projectItem={i}
            filter={filter === tagsArr[0].attributes.tag ? null : filter}
            key={i.projectId}
          />
        ))}
      </div>
    </>
  );
};

export default GridProjectsClient;
